<template>
    <div class="page-root">
        <div class="fd-detail-main" id="printcontent">
            <h1 class="fd-news-title">{{ title }}</h1>
            <div class="fd-news-message">
                <p>发布时间：{{ date }}</p>
                <p>发布：{{ fy }}</p>
                <div class="fd-detail-cz">
                    <div class="fd-font-cz">字号：
                        <span class="fd-large" @click="addFontSize"></span>
                        <span class="fd-narrow" @click="narFontSize"></span>
                    </div>
                    <div class="fd-print" @click="printPage">打印本页</div>
                </div>
            </div>
            <div class="fd-detail-con" :style="{'font-size':`${fontSize}px`}">
                <div class="fd-voice-bg" v-if="spdz && spdz!=='' && xwlb==='5'">
                    <video :src="spdz" controls="controls" autoplay="autoplay"></video>
                </div>
                <p v-html="content"></p>
                <div v-if="fileList.length">
                    <div class="fd-xgfj-title">相关附件</div>
                    <div class="fd-xgfj-list"
                         v-for="(item, index) in fileList"
                         :key="`xgfj${index}`"
                         @click="downloadFile(item.bh, item.wjmc)"
                         v-text="item.wjmc"></div>
                </div>
            </div>
        </div>

        <!-- 悬浮组：包裹 图标 + 二维码 -->
        <div
                class="float-share-group"
                @mouseenter="showQrcode=true"
                @mouseleave="showQrcode=false"
        >
            <!-- 微信图标 + 上方文字 -->
            <div class="float-share-btn">
                <div class="share-text">分享</div>  <!-- 这里加分享文字 -->
                <img src="/static/image/wx.png" alt="微信" class="share-img">
            </div>

            <!-- 二维码 -->
            <div class="qrcode-container" v-show="showQrcode">
                <img src="#" alt="稿件分享二维码" class="qrcode-img">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
                navList: [],
                title: '',
                date: '',
                fy: '',
                spdz: '',
                spfm: '',
                fontSize: 18,
                content: '',
                fileList: [],
                xwlb: '',
                showQrcode: false
            };
        },
        mounted() {
            this.initData();
            this.initFileList();
        },
        methods: {
            initData() {
                const url = window.fdConfig.url.xwzx.selectById.replace('{id}', this.$route.query.bh);
                window.fdGlobal.ajax.get(url)
                    .then((res) => {
                        if (res.data) {
                            this.title = res.data.bt;
                            this.date = res.data.fbsj.slice(0, 10);
                            this.spdz = res.data.spdz;
                            this.xwlb = res.data.xwlb;
                            this.spfm = res.data.spfm;
                            this.fy = res.data.fbdwTranslateText;
                            this.content = res.data.xwnr;
                            this.qrCodeUrl = res.data.qrCodeUrl;

                            setTimeout(() => {
                                let img = document.querySelector('.qrcode-img');
                                if (img) {
                                    img.src = this.qrCodeUrl + "?t=" + new Date().getTime();
                                    img.onerror = function () {
                                        console.log("图片加载失败：", img.src);
                                        this.src = "/static/images/default-qrcode.png";
                                    };
                                }
                            }, 100);

                            this.content = this.content.replace(/font-size/g, '');
                            this.content = this.content.replace(/line-height/g, '');
                        }
                    });
            },
            addFontSize() {
                this.fontSize += 2;
            },
            narFontSize() {
                if (this.fontSize > 10) {
                    this.fontSize -= 2;
                }
            },
            printPage() {
                window.print();
            },
            initFileList() {
                const url = window.fdConfig.url.common.getFile;
                window.fdGlobal.ajax({
                    url: url,
                    method: window.fdConfig.methodGet,
                    params: {
                        businessId: this.$route.query.bh,
                        type: Number(this.$route.query.fileType),
                        ext: 'XIN_WEN_ZI_XUN'
                    }
                })
                    .then((res) => {
                        this.fileList = res.data;
                    });
            },
            downloadFile(bh, wjmc) {
                window.fdGlobal.ajax({
                    method: window.fdConfig.methodGet,
                    url: window.fdConfig.url.common.downloadFile.replace('{id}', bh),
                    contentType: 'application/json;charset=utf-8',
                    responseType: 'blob'
                })
                    .then((res) => {
                        const binaryData = [];
                        const template = res.data;
                        binaryData.push(template);
                        const blob = new Blob(binaryData);
                        if ('download' in document.createElement('a')) {
                            const elink = document.createElement('a');
                            elink.download = wjmc;
                            elink.style.display = 'none';
                            elink.href = URL.createObjectURL(blob);
                            document.body.appendChild(elink);
                            elink.click();
                            URL.revokeObjectURL(elink.href);
                            document.body.removeChild(elink);
                        } else {
                            navigator.msSaveBlob(blob, wjmc);
                        }
                    });
            }
        }
    };
</script>
<style lang="less" scoped>
    .fd-voice-bg {
        margin: 0 auto 44px;
        padding: 55px 0;
        width: 768px;
        height: 512px;
        background-color: #000;

        video {
            width: 100%;
            height: 100%;
        }
    }

    .fd-xgfj-title {
        margin-top: 45px;
        padding-left: 23px;
        color: #000;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 1px;
        background: url(~@/images/common/icon-file.png) left center no-repeat;
    }

    .fd-xgfj-list {
        margin-top: 8px;
        margin-left: 23px;
        color: #0053b4;
        font-size: 16px;
        line-height: 21px;
        cursor: pointer;
    }

    .page-root {
        position: relative;
        min-height: 100vh;
    }

    /* 悬浮组：把图标和二维码包成一个整体 */
    .float-share-group {
        position: fixed;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 9999;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    /* 放大的椭圆背景 */
    .float-share-btn {
        width: 60px;
        height: 80px;
        background-color: #ffffff;
        border-radius: 35px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        padding: 10px 6px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &:hover {
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
            transform: scale(1.05);
        }
    }

    .share-img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        object-fit: cover;
    }

    /* 分享文字 */
    .share-text {
        font-size: 13px;
        color: #333;
        margin-bottom: 6px;
        font-weight: 500;
        text-align: center;
        line-height: 1.2;
    }

    .qrcode-container {
        padding: 15px;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.15);
        text-align: center;
    }

    .qrcode-img {
        width: 200px;
        height: 200px;
        display: block;
        border: 1px solid #f5f5f5;
        object-fit: cover;
    }
</style>
